import { Signal, computed, inject, resource } from "@angular/core";

import { HealthRecord } from "../../../apis/stats/rest/models";
import { HealthService } from "../../../apis/stats/rest/services";
import { EMPTY_HEALTH } from "../../models/HealthIndicator";

export function serviceHealth(
  service: Signal<{ subscriptionId: string; healthSubscriptionId?: string | null } | undefined | null>,
): Signal<HealthRecord> {
  const source = inject(HealthService);

  const loader = resource({
    params: () => {
      const s = service();
      return s ? { subscription_id: s.healthSubscriptionId ?? s.subscriptionId } : undefined;
    },
    loader: ({ params }) =>
      source.getNetworkHealthByServiceId(params).catch(() => {
        console.warn(`Failed fetching health for service ${params.subscription_id}`);
        return EMPTY_HEALTH;
      }),
    defaultValue: EMPTY_HEALTH,
  });

  return computed(() => loader.value() ?? EMPTY_HEALTH);
}
